var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmarkMedium = function SvgBookmarkMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "-8 -8 35 35"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#33F",
    strokeWidth: 2,
    d: "M4 17.939V1h12v16.95l-5.416-4.23-.618-.483-.617.486zM3.378 5.235H17"
  })));
};
export default SvgBookmarkMedium;